import { ReferencedEntry } from 'contentful';
import React from 'react';
import { transformContentfulObject } from 'src/services/cms/transformers/contentful';

interface ContentfulModuleWrapperProps<ContentType> {
  entry: ReferencedEntry<ContentType>;
}

/**
 * This HOC component works with ModuleWrapper to wrap Contentful components, allowing you to keep the
 * components separated.
 *
 * @param {React.FunctionComponent} Component The functional component which requires data from contentful
 * @returns {React.FC} Returns another component that handles the wrapping and flattening of data
 * @see function ModuleWrapper in src/components/PageAssembly/ModuleWrapper/ModuleWrapper.tsx
 */
export const ContentfulModuleWrapper = <ContentType extends object>(Component: React.FunctionComponent<any>) => {
  const wrapperComponent: React.FC<ContentfulModuleWrapperProps<ContentType>> = ({ entry, ...props }) => {
    const componentProps = transformContentfulObject(entry, props);
    return (
      <Component {...componentProps} />
    );
  };
  wrapperComponent.displayName = 'ContentfulModuleWrapper';
  return wrapperComponent;
};
